import cn from "classnames";
import "./sectionHeader.scss";
import { PublishStatus } from "components/common/PublishStatus";
import { type PropsWithChildren, type ReactNode } from "react";
import { type PublishedStatusType } from "enums";

type Props = {
  header?: ReactNode;
  publishedStatus: PublishedStatusType;
  className?: string;
  style?: object;
};

export function SectionHeader(props: Props & PropsWithChildren) {
  const { children, className, style, header, publishedStatus } = props;

  return (
    <div className={cn("section-header", className)} style={style}>
      <div className="left-part">
        {header}
        <PublishStatus muted publishedStatus={publishedStatus} />
      </div>
      <div className="header-content-container">{children}</div>
    </div>
  );
}

SectionHeader.propTypes = {};

export default SectionHeader;
